export const buildKdRows = (calculationResult) => {
  const valueTableData = calculationResult ? calculationResult.valuesTableData : null;
  const rows = [];

  if (
    valueTableData &&
    valueTableData.speed &&
    valueTableData.power &&
    valueTableData.rpm
  ) {
    const speeds = valueTableData.speed || [];
    const powers = valueTableData.power || [];
    const rpms = valueTableData.rpm || [];
    const isoConsumptions = valueTableData.isoDailyConsumption || [];
    const actualConsumptions =
      valueTableData.consumption || valueTableData.daily_consumption || [];
    const auxConsumption = valueTableData.auxiliaryConsumption || 0;

    const measuredIsoConsumptions = valueTableData.measuredIsoConsumption || [];
    const medianMeasuredConsumptions = valueTableData.medianMeasuredConsumption || [];

    for (let i = 0; i < Math.min(speeds.length, 50); i++) {
      const speed = speeds[i];

      if (
        Number(speed) >= 10 &&
  (Number.isInteger(Number(speed)) || Math.abs(Number(speed) - Math.round(Number(speed))) < 0.01)
      ) {
        const actualFoc = actualConsumptions[i] || 0;
        const totalFoc = actualFoc + auxConsumption;

        const measuredIso = measuredIsoConsumptions[i];
        const medianMeasured = medianMeasuredConsumptions[i];

        rows.push({
          speed: Math.round(speed).toString(),
          rpm: (rpms[i] || 0).toFixed(2),
          power: (powers[i] || 0).toFixed(0),

          kdIsoFoc: (isoConsumptions[i] || 0).toFixed(2),
          kdActualFoc: (totalFoc || 0).toFixed(2),

          dataIsoFoc:
            measuredIso !== null &&
            measuredIso !== undefined &&
            !isNaN(Number(measuredIso))
              ? Number(measuredIso).toFixed(2)
              : "-",

          dataActualFoc:
            medianMeasured !== null &&
            medianMeasured !== undefined &&
            !isNaN(Number(medianMeasured))
              ? (Number(medianMeasured) + auxConsumption).toFixed(2)
              : "-",
        });
      }
    }
  }

  return rows;
};

const makeKdFootnote = () => ({
  margin: [0, 2, 0, 8],
  table: {
    widths: ["auto", "*"],
    body: [
      [
        {
          text: "KD FOC",
          bold: true,
          color: "#243b53",
          fontSize: 7.5,
          border: [false, false, false, false],
        },
        {
          text:
            "Daily fuel oil consumption predicted by the KD models.",
          color: "#6b7280",
          fontSize: 7.5,
          border: [false, false, false, false],
        },
      ],
      [
        {
          text: "KD FOC ISO Corrected",
          bold: true,
          color: "#243b53",
          fontSize: 7.5,
          border: [false, false, false, false],
        },
        {
          text:
            "Daily fuel oil consumption predicted by the KD models and corrected based on the shop test ISO BSFC",
          color: "#6b7280",
          fontSize: 7.5,
          border: [false, false, false, false],
        },
      ],
      [
        {
          text: "Measured FOC",
          bold: true,
          color: "#243b53",
          fontSize: 7.5,
          border: [false, false, false, false],
        },
        {
          text:
            "Daily measured fuel oil consumption from telemetry.",
          color: "#6b7280",
          fontSize: 7.5,
          border: [false, false, false, false],
        },
      ],
      [
        {
          text: "Measured FOC ISO Corrected",
          bold: true,
          color: "#243b53",
          fontSize: 7.5,
          border: [false, false, false, false],
        },
        {
          text:
            "Daily measured fuel oil consumption from telemetry corrected based on the shop test ISO BSFC.",
          color: "#6b7280",
          fontSize: 7.5,
          border: [false, false, false, false],
        },
      ],
      [
        {
          text: "Green",
          color: "#15803d",
          bold: true,
          fontSize: 7.5,
          border: [false, false, false, false],
        },
        {
          text: "difference between reported and predicted FOC ≤ 2 tn/day",
          color: "#6b7280",
          fontSize: 7.5,
          border: [false, false, false, false],
        },
      ],
      [
        {
          text: "Red",
          color: "#b91c1c",
          bold: true,
          fontSize: 7.5,
          border: [false, false, false, false],
        },
        {
          text: "difference between reported and predicted FOC > 2 tn/day",
          color: "#6b7280",
          fontSize: 7.5,
          border: [false, false, false, false],
        },
      ],
    ],
  },
  layout: {
    hLineWidth: function () {
      return 0;
    },
    vLineWidth: function () {
      return 0;
    },
    fillColor: function () {
      return "#f8fafc";
    },
    paddingLeft: function () {
      return 6;
    },
    paddingRight: function () {
      return 6;
    },
    paddingTop: function () {
      return 3;
    },
    paddingBottom: function () {
      return 3;
    },
  },
});

const emptyValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  return String(value);
};

const getActualFocComparisonStyle = (kdActualFoc, dataActualFoc) => {
  const kdValue = Number(kdActualFoc);
  const dataValue = Number(dataActualFoc);

  if (
    !isFinite(kdValue) ||
    !isFinite(dataValue) ||
    kdValue <= 10 ||
    dataValue <= 10
  ) {
    return {};
  }

  const difference = Math.abs(kdValue - dataValue);

  if (difference > 2) {
    return {
      color: "#d65e5e",
      bold: true,
    };
  }

  return {
    color: "#49c275",
    bold: true,
  };
};

const professionalTableLayout = {
  hLineWidth: function (i, node) {
    if (i === 0 || i === node.table.body.length) {
      return 0.8;
    }

    if (i === 1) {
      return 0.7;
    }

    return 0.35;
  },

  vLineWidth: function (i, node) {
    if (i === 0 || i === node.table.widths.length) {
      return 0.8;
    }

    return 0.35;
  },

  hLineColor: function (i) {
    if (i === 0 || i === 1) {
      return "#8fa1b3";
    }

    return "#c7d0da";
  },

  vLineColor: function (i, node) {
    if (i === 0 || i === node.table.widths.length) {
      return "#8fa1b3";
    }

    return "#c7d0da";
  },

  fillColor: function (rowIndex) {
    if (rowIndex === 0) {
      return "#e7edf4";
    }

    return rowIndex % 2 === 0 ? "#fafbfd" : null;
  },

  paddingLeft: function () {
    return 5;
  },

  paddingRight: function () {
    return 5;
  },

  paddingTop: function () {
    return 4;
  },

  paddingBottom: function () {
    return 4;
  },
};

const makeInfoTable = (rows) => ({
  table: {
    widths: ["28%", "47%", "25%"],
    body: [
      [
        { text: "Field", style: "tableHeader" },
        { text: "Description", style: "tableHeader" },
        { text: "Value", style: "tableHeader" },
      ],
      ...rows.map((row) => [
        { text: emptyValue(row.label), style: "labelCell" },
        { text: emptyValue(row.description), style: "descCell" },
        { text: emptyValue(row.value), style: "valueCell" },
      ]),
    ],
  },
  layout: professionalTableLayout,
  margin: [0, 0, 0, 8],
});

const makeSensorIssuesTable = (sensorIssues) => {
  const body = [
    [
      { text: "Triggered Date", style: "tableHeader" },
      { text: "Missing Data Point(s)", style: "tableHeader" },
      { text: "Issue Description", style: "tableHeader" },
    ],
  ];

  if (!sensorIssues || sensorIssues.length === 0) {
    body.push([
      {
        text: "No sensor issues",
        colSpan: 3,
        style: "placeholderCell",
      },
      {},
      {},
    ]);
  } else {
    sensorIssues.forEach((issue) => {
      body.push([
        { text: emptyValue(issue.registeredDateString), style: "valueCell" },
        { text: emptyValue(issue.sensorName), style: "valueCell" },
        { text: emptyValue(issue.faultType), style: "valueCell" },
      ]);
    });
  }

  return {
    table: {
      widths: ["25%", "35%", "40%"],
      body,
    },
    layout: professionalTableLayout,
    margin: [0, 0, 0, 8],
  };
};

const makeKdTable = (rows) => {
  const body = [
    [
      { text: "Speed\n(kn)", style: "tableHeaderSmall" },
      { text: "RPM", style: "tableHeaderSmall" },
      { text: "Power\n(kW)", style: "tableHeaderSmall" },
      { text: "KD FOC\n ISO Corrected\n\n(tn/day)", style: "tableHeaderSmall" },
      { text: "KD \nFOC\n(tn/day)", style: "tableHeaderSmall" },
      { text: "Measured FOC\n ISO Corrected\n(tn/day)", style: "tableHeaderSmall" },
      { text: "Measured FOC\n(tn/day)", style: "tableHeaderSmall" },
    ],
  ];

  if (!rows || rows.length === 0) {
    body.push([
      {
        text: "No data available",
        colSpan: 7,
        style: "placeholderCell",
      },
      {},
      {},
      {},
      {},
      {},
      {},
    ]);
  } else {
    rows.forEach((row) => {
      const actualFocStyle = getActualFocComparisonStyle(
        row.kdActualFoc,
        row.dataActualFoc
      );

      body.push([
        { text: emptyValue(row.speed), style: "valueCellSmall" },
        { text: emptyValue(row.rpm), style: "valueCellSmall" },
        { text: emptyValue(row.power), style: "valueCellSmall" },
        { text: emptyValue(row.kdIsoFoc), style: "valueCellSmall" },
        {
          text: emptyValue(row.kdActualFoc),
          style: "valueCellSmall",
          ...actualFocStyle,
        },
        { text: emptyValue(row.dataIsoFoc), style: "valueCellSmall" },
        {
          text: emptyValue(row.dataActualFoc),
          style: "valueCellSmall",
          ...actualFocStyle,
        },
      ]);
    });
  }

  return {
    table: {
      widths: ["10%", "10%", "12%", "17%", "17%", "17%", "17%"],
      body,
    },
    layout: professionalTableLayout,
    margin: [0, 0, 0, 10],
  };
};

export const buildPerformanceReportDocDefinition = (data) => ({
  pageSize: "A4",
  pageOrientation: "portrait",
  pageMargins: [30, 35, 30, 35],

  info: {
    title: `${data.reportTitle} - ${data.vessel}`,
    author: data.reportAuthor,
    subject: data.reportSubject,
    keywords: [
      "vessel performance",
      "voyage report",
      "CII",
      "K-Diagram",
      "fouling",
      "slime",
      data.vessel,
    ].join(", "),
  },

  footer(currentPage, pageCount) {
    return {
      text: `Page ${currentPage} of ${pageCount}`,
      alignment: "center",
      fontSize: 8,
      color: "#777",
      margin: [0, 8, 0, 0],
    };
  },

  content: [
    {
      text: data.reportTitle,
      style: "mainTitle",
    },

    {
      text: [
        "Vessel: ",
        { text: emptyValue(data.vessel), bold: true },
        "  |  Prepared: ",
        { text: emptyValue(data.today), bold: true },
      ],
      style: "subtitle",
    },

    {
      text: "VOYAGE SUMMARY",
      style: "voyageTitle",
    },

    {
      text: "1. Trip Characteristics",
      style: "sectionTitle",
    },

    {
      text: "1.1 Core Details",
      style: "subTitle",
    },

    makeInfoTable([
      {
        label: "From Port",
        description: "Departure Port Name",
        value: data.departurePort,
      },
      {
        label: "To Port",
        description: "Arrival Port Name",
        value: data.arrivalPort,
      },
      {
        label: "Start Date",
        description: "Date of trip commencement",
        value: data.startDate,
      },
      {
        label: "End Date",
        description: "Date of trip completion",
        value: data.stopDate,
      },
      {
        label: "Departure Time",
        description: "Departure time",
        value: data.departureTime,
      },
      {
        label: "Distance Travelled",
        description: "Total distance covered (NM)",
        value: data.totalDistRun,
      },
      {
        label: data.hfoLabel,
        description: `${data.hfoLabel} Consumption (MT)`,
        value: data.hfo,
      },
      {
        label: "MGO",
        description: "Marine Gas Oil Consumption (MT)",
        value: data.mgo,
      },
      {
        label: data.lfoLabel,
        description: `${data.lfoLabel} Consumption (MT)`,
        value: data.lfo,
      },
      {
        label: "CII Rating",
        description: "Carbon Intensity Indicator",
        value: data.ciiValue,
      },
    ]),

    {
      text: "1.2 Weather Information",
      style: "subTitle",
    },

    makeInfoTable([
      {
        label: "Average Wind Speed",
        description: "Average wind speed encountered",
        value: data.avg_wind_speed || "-",
      },
      {
        label: "Average Wave Height",
        description: "Average wave height encountered",
        value: data.avg_wave_height || "-",
      },
      {
        label: "Predominant Weather",
        description: "General weather description",
        value: data.gen_weather_desc || "-",
      },
    ]),

    {
      text: "1.3 Performance Indicators",
      style: "subTitle",
    },

    makeInfoTable([
      {
        label: "Overconsumption",
        description: "Fuel overconsumption analysis",
        value: data.overconsumption,
      },

      {
        label: "Fouling",
        description: "Hull fouling status",
        value: data.fouling,
      },
    ]),

    {
      text: "1.4 Sensor Issues",
      style: "subTitle",
    },

    makeSensorIssuesTable(data.sensorIssues),

    {
      text: "2. Fouling Analysis",
      style: "sectionTitle",
    },

    {
      text: "2.1 Fouling Assessment",
      style: "subTitle",
    },

    {
      ul: [
        {
          text: [
            { text: "Hull Fouling Indicator — ", bold: true },
            "Calculated increase in power/consumption vs. clean hull baseline.",
          ],
        },
        {
          text: [
            "Last Cleaning Date: ",
            { text: emptyValue(data.lastCleaningDate), bold: true },
            "    Fouling Percentage: ",
            { text: emptyValue(data.fouling), bold: true },
          ],
        },
      ],
      style: "bulletSection",
      margin: [8, 0, 0, 10],
    },

    {
      text: "3. Speed Consumption - Good Weather Table",
      style: "sectionTitle",
      //pageBreak: "before",
    },

    {
      text: `3.1 Laden (Draft: ${emptyValue(data.ladenDraft)} m, Trim: ${emptyValue(data.ladenTrim)} m)`,
      style: "subTitle",
    },

    makeKdTable(data.ladenRows),

    {
      text: `3.2 Ballast (Draft: ${emptyValue(data.ballastDraft)} m, Trim: ${emptyValue(data.ballastTrim)} m)`,
      style: "subTitle",
    },

    makeKdTable(data.ballastRows),
    makeKdFootnote(),
  ],

  styles: {
    mainTitle: {
      fontSize: 14,
      bold: true,
      alignment: "center",
      color: "#1a3a5c",
      margin: [0, 0, 0, 0],
    },

    subtitle: {
      fontSize: 8,
      alignment: "center",
      color: "#555",
      margin: [0, 8, 0, 18],
    },

    voyageTitle: {
      fontSize: 13,
      bold: true,
      color: "#ffffff",
      fillColor: "#1a3a5c",
      margin: [0, 4, 0, 10],
    },

    sectionTitle: {
      fontSize: 12,
      bold: true,
      color: "#1a3a5c",
      fillColor: "#d0dce8",
      margin: [0, 8, 0, 9],
    },

    subTitle: {
      fontSize: 10.5,
      bold: true,
      color: "#1a3a5c",
      margin: [0, 5, 0, 2],
    },

    tableHeader: {
      fontSize: 8.5,
      bold: true,
      color: "#243b53",
      alignment: "center",
      margin: [2, 2, 2, 2],
    },

    tableHeaderSmall: {
      fontSize: 8,
      bold: true,
      color: "#243b53",
      alignment: "center",
      margin: [1, 2, 1, 2],
    },

    labelCell: {
      fontSize: 8.5,
      bold: true,
      color: "#263238",
      alignment: "left",
      margin: [2, 2, 2, 2],
    },

    descCell: {
      fontSize: 8.5,
      color: "#455a64",
      alignment: "left",
      margin: [2, 2, 2, 2],
    },

    valueCell: {
      fontSize: 8.5,
      color: "#37474f",
      alignment: "center",
      margin: [2, 2, 2, 2],
    },

    valueCellSmall: {
      fontSize: 8.3,
      color: "#37474f",
      alignment: "center",
      margin: [1, 2, 1, 2],
    },

    placeholderCell: {
      fontSize: 8.5,
      color: "#7b8794",
      italics: true,
      alignment: "center",
      margin: [2, 4, 2, 4],
    },

    bulletSection: {
      fontSize: 8.7,
      color: "#333",
    },
  },

  defaultStyle: {
    font: "Roboto",
    fontSize: 10,
  },
  footnote: {
    fontSize: 7,
    color: "#6b7280",
    italics: true,
    alignment: "left",
  },
});
